import { useState } from 'react';

import ContentManager from './components/ContentManager';
import SEOManager from './components/SEOManager';
import FormManager from './components/FormManager';
import SettingsManager from './components/SettingsManager';
import BrochureManager from './components/BrochureManager';
import BlogManager from './components/BlogManager';
import AdminProtectedRoute from '../../components/admin/AdminProtectedRoute';
import { useAdminAuth } from '../../hooks/useAdminAuth';

const AdminPage = () => {
  const [activeTab, setActiveTab] = useState<'content' | 'seo' | 'forms' | 'brochures' | 'blog' | 'settings'>('content');
  const { logout } = useAdminAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <AdminProtectedRoute>
      <div className="min-h-screen bg-black text-white">
        <div className="container mx-auto px-4 py-12">
          <div className="flex justify-between items-center mb-8">
            <div>
              <h1 className="text-4xl font-light mb-2">
                Admin <span className="font-bold text-[#C5A46D]">Panel</span>
              </h1>
              <p className="text-gray-400">Manage your website content, SEO settings, and form submissions</p>
            </div>
            <button
              onClick={handleLogout}
              className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-200"
            >
              Logout
            </button>
          </div>

        {/* Tab Navigation */}
        <div className="flex space-x-4 mb-8 border-b border-gray-800">
          <button
            onClick={() => setActiveTab('content')}
            className={`px-6 py-3 font-medium transition-all duration-300 ${
              activeTab === 'content'
                ? 'text-[#C5A46D] border-b-2 border-[#C5A46D]'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            <i className="ri-file-text-line mr-2"></i>
            Content Management
          </button>
          <button
            onClick={() => setActiveTab('seo')}
            className={`px-6 py-3 font-medium transition-all duration-300 ${
              activeTab === 'seo'
                ? 'text-[#C5A46D] border-b-2 border-[#C5A46D]'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            <i className="ri-search-line mr-2"></i>
            SEO Settings
          </button>
          <button
            onClick={() => setActiveTab('forms')}
            className={`px-6 py-3 font-medium transition-all duration-300 ${
              activeTab === 'forms'
                ? 'text-[#C5A46D] border-b-2 border-[#C5A46D]'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            <i className="ri-mail-line mr-2"></i>
            Form Submissions
          </button>
          <button
            onClick={() => setActiveTab('brochures')}
            className={`px-6 py-3 font-medium transition-all duration-300 ${
              activeTab === 'brochures'
                ? 'text-[#C5A46D] border-b-2 border-[#C5A46D]'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            <i className="ri-file-pdf-line mr-2"></i>
            Catalog / Brochures
          </button>
          <button
            onClick={() => setActiveTab('blog')}
            className={`px-6 py-3 font-medium transition-all duration-300 ${
              activeTab === 'blog'
                ? 'text-[#C5A46D] border-b-2 border-[#C5A46D]'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            <i className="ri-article-line mr-2"></i>
            Blog Management
          </button>
          <button
            onClick={() => setActiveTab('settings')}
            className={`px-6 py-3 font-medium transition-all duration-300 ${
              activeTab === 'settings'
                ? 'text-[#C5A46D] border-b-2 border-[#C5A46D]'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            <i className="ri-settings-3-line mr-2"></i>
            Settings
          </button>
        </div>

        {/* Tab Content */}
        <div className="bg-gray-900 rounded-lg p-8">
          {activeTab === 'content' && <ContentManager />}
          {activeTab === 'seo' && <SEOManager />}
          {activeTab === 'forms' && <FormManager />}
          {activeTab === 'brochures' && <BrochureManager />}
          {activeTab === 'blog' && <BlogManager />}
          {activeTab === 'settings' && <SettingsManager />}
        </div>
      </div>
    </div>
    </AdminProtectedRoute>
  );
};

export default AdminPage;
